import {BaseComponent} from "react-vextensions";
import {EngineConfig_Alarms, EngineConfig_XAlarm} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_Alarms.js";
import {EngineConfig_Phases} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_Phases.js";
import {EngineConfig_Background} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_Background.js";
import {EngineConfig_Camera} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_Camera.js";
import {EngineConfig_DreamNarration} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_DreamNarration.js";
import {EngineConfig_DreamQuiz} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_DreamQuiz.js";
import {EngineConfig_DreamRecall} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_DreamRecall.js";
import {EngineConfig_DreamTranscribe} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_DreamTranscribe.js";
import {EngineConfig_EEG} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_EEG.js";
import {EngineConfig_General} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_General.js";
import {EngineConfig_Gyro} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_Gyro.js";
import {EngineConfig_JourneyEntry} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_JourneyEntry.js";
import {EngineConfig_JourneyGrid} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_JourneyGrid.js";
import {EngineConfig_JourneyTraining} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_JourneyTraining.js";
import {EngineConfig_JourneyVisualization} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_JourneyVisualization.js";
import {EngineConfig_Memory} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_Memory.js";
import {EngineConfig_MicroSnooze} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_MicroSnooze.js";
import {EngineConfig_ModeSwitcher} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_ModeSwitcher.js";
import {EngineConfig_StoryExplore} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_StoryExplore.js";
import {AlarmSequence, AlarmType, SequenceIsSemiEnabled} from "../../Server/DB/engineConfigs/@EngineConfig/Alarms/@AlarmConfig.js";
import {Alarms_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/Alarms_ConfigUI.js";
import {Phases_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/Phases_ConfigUI.js";
import {Background_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/Background_ConfigUI.js";
import {CameraPanel} from "../../UI/Engine/Engine/SessionTabPanels/Camera_ConfigUI.js";
import {DreamNarration_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/DreamNarration_ConfigUI.js";
import {DreamQuiz_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/DreamQuiz_ConfigUI.js";
import {DreamRecall_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/DreamRecall_ConfigUI.js";
import {DreamTranscribe_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/DreamTranscribe_ConfigUI.js";
import {EEG_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/EEG_ConfigUI.js";
import {EffectCountsPanel} from "../../UI/Engine/Engine/SessionTabPanels/EffectCountsPanel.js";
import {General_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/General_ConfigUI.js";
import {Gyro_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/Gyro_ConfigUI.js";
import {JourneyEntry_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/JourneyEntry_ConfigUI.js";
import {JourneyGrid_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/JourneyGrid_ConfigUI.js";
import {JourneyTraining_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/JourneyTraining_ConfigUI.js";
import {JourneyVisualization_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/JourneyVisualization_ConfigUI.js";
import {Memory_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/Memory_ConfigUI.js";
import {MicroSnooze_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/MicroSnooze_ConfigUI.js";
import {ModeSwitcher_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/ModeSwitcher_ConfigUI.js";
import {StoryExplore_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/StoryExplore_ConfigUI.js";
import {LiveSession} from "../LiveSession.js";
import {CountdownAlarmComp} from "./Components/AlarmComps/CountdownAlarmComp.js";
import {LightAlarmComp} from "./Components/AlarmComps/LightAlarmComp.js";
import {ScriptAlarmComp} from "./Components/AlarmComps/ScriptAlarmComp.js";
import {ShakeAlarmComp} from "./Components/AlarmComps/ShakeAlarmComp.js";
import {SoundAlarmComp} from "./Components/AlarmComps/SoundAlarmComp.js";
import {AlarmsComp} from "./Components/AlarmsComp.js";
import {PhasesComp} from "./Components/PhasesComp.js";
import {BackgroundComp} from "./Components/BackgroundComp.js";
import {CameraComp} from "./Components/CameraComp.js";
import {DreamNarrationComp} from "./Components/DreamNarrationComp.js";
import {DreamQuizComp} from "./Components/DreamQuizComp.js";
import {DreamRecallComp} from "./Components/DreamRecallComp.js";
import {DreamTranscribeComp} from "./Components/DreamTranscribeComp.js";
import {EEGComp} from "./Components/EEGComp.js";
import {EngineSessionComp} from "./Components/EngineSessionComp.js";
import {GeneralComp} from "./Components/GeneralComp.js";
import {GyroComp} from "./Components/GyroComp.js";
import {JourneyEntryComp} from "./Components/JourneyEntryComp.js";
import {JourneyGridComp} from "./Components/JourneyGridComp.js";
import {JourneyTrainingComp} from "./Components/JourneyTrainingComp.js";
import {JourneyVisualizationComp} from "./Components/JourneyVisualizationComp.js";
import {MemoryComp} from "./Components/MemoryComp.js";
import {MicroSnoozeComp} from "./Components/MicroSnoozeComp.js";
import {ModeSwitcherComp} from "./Components/ModeSwitcherComp.js";
import {StoryExploreComp} from "./Components/StoryExploreComp.js";
import {EngineConfig_ConceptLink} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_ConceptLink.js";
import {ConceptLinkComp} from "./Components/ConceptLinkComp.js";
import {ConceptLink_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/ConceptLink_ConfigUI.js";
import {RealityCheck_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/RealityCheck_ConfigUI.js";
import {EngineConfig_RealityCheck} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_RealityCheck.js";
import {RealityCheckComp} from "./Components/RealityCheckComp.js";
import {SignalsComp} from "./Components/SignalsComp.js";
import {Signals_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/Signals_ConfigUI.js";
import {VR_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/VR_ConfigUI.js";
import {VRComp} from "./Components/VRComp.js";
import {EngineConfig_VR} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_VR.js";
import {EngineConfig_Breath} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_Breath.js";
import {BreathComp} from "./Components/BreathComp.js";
import {Breath_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/Breath_ConfigUI.js";
import {EngineConfig_Variants} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_Variants.js";
import {VariantsComp} from "./Components/VariantsComp.js";
import {Variants_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/Variants_ConfigUI.js";
import {EngineConfig_MemoryPalace} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_MemoryPalace.js";
import {MemoryPalace_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/MemoryPalace_ConfigUI.js";
import {MemoryPalaceComp} from "./Components/MemoryPalaceComp.js";
import {EngineConfig_Visualization} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_Visualization.js";
import {VisualizationComp} from "./Components/VisualizationComp.js";
import {Visualization_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/Visualization_ConfigUI.js";
import {Media_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/Media_ConfigUI.js";
import {EngineConfig_Media} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_Media.js";
import {MediaComp} from "./Components/MediaComp.js";
import {Alerts_ConfigUI} from "../../UI/Engine/Engine/SessionTabPanels/Alerts_ConfigUI.js";
import {AlertsComp} from "./Components/AlertsComp.js";
import {EngineConfig_Alerts} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_Alerts.js";

// Main purpose of this collection: To ensure each engine-config script file "executes at runtime", so the AJV definitions get registered.
// Secondary purpose: To allow "finding" of an engine-session component-class by name. (without needing a live session)
export const engineCompClasses: Array<[any, new(..._)=>EngineSessionComp]> = [
	[EngineConfig_Variants, VariantsComp],
	[EngineConfig_General, GeneralComp],
	[EngineConfig_ModeSwitcher, ModeSwitcherComp],
	[EngineConfig_Background, BackgroundComp],
	[EngineConfig_Alerts, AlertsComp],
	[EngineConfig_Camera, CameraComp],
	[EngineConfig_Gyro, GyroComp],
	[EngineConfig_EEG, EEGComp],
	[EngineConfig_Breath, BreathComp],
	[EngineConfig_Phases, PhasesComp],
	[EngineConfig_Alarms, AlarmsComp],
	[EngineConfig_MicroSnooze, MicroSnoozeComp],
	[EngineConfig_Memory, MemoryComp],
	[EngineConfig_MemoryPalace, MemoryPalaceComp],
	[EngineConfig_VR, VRComp],
	[EngineConfig_DreamTranscribe, DreamTranscribeComp],
	[EngineConfig_DreamNarration, DreamNarrationComp],
	[EngineConfig_DreamRecall, DreamRecallComp],
	[EngineConfig_DreamQuiz, DreamQuizComp],
	[EngineConfig_ConceptLink, ConceptLinkComp],
	[EngineConfig_RealityCheck, RealityCheckComp],
	[EngineConfig_StoryExplore, StoryExploreComp],
	[EngineConfig_Visualization, VisualizationComp],
	[EngineConfig_Media, MediaComp],
	[EngineConfig_JourneyTraining, JourneyTrainingComp],
	[EngineConfig_JourneyVisualization, JourneyVisualizationComp],
	[EngineConfig_JourneyGrid, JourneyGridComp],
	[EngineConfig_JourneyEntry, JourneyEntryComp],
];

// we extract this into a standalone function, for close proximity to collection above (so we don't forget updating one with the other)
/** Call this using LiveSession_CreateComponents.call(session). [since AddComponent func is protected] */
export function LiveSession_CreateComponents(this: LiveSession) {
	// oxlint-disable no-this-in-sfc
	this.AddComponent(new VariantsComp(this, this.c.variants));
	this.AddComponent(new GeneralComp(this, this.c.general));
	this.AddComponent(new ModeSwitcherComp(this, this.c.modeSwitcher));
	this.AddComponent(new BackgroundComp(this, this.c.background));
	this.AddComponent(new AlertsComp(this, this.c.alerts));
	this.AddComponent(new CameraComp(this, this.c.camera));
	this.AddComponent(new GyroComp(this, this.c.gyro));
	this.AddComponent(new EEGComp(this, this.c.eeg));
	this.AddComponent(new BreathComp(this, this.c.breath));
	this.AddComponent(new PhasesComp(this, this.c.phases));
	this.AddComponent(new AlarmsComp(this, this.c.alarms));
	this.AddComponent(new MicroSnoozeComp(this, this.c.microSnooze));
	this.AddComponent(new MemoryComp(this, this.c.memory, this.hc.memory));
	this.AddComponent(new MemoryPalaceComp(this, this.c.memoryPalace));
	this.AddComponent(new VRComp(this, this.c.vr));
	this.AddComponent(new DreamTranscribeComp(this, this.c.dreamTranscribe));
	this.AddComponent(new DreamNarrationComp(this, this.c.dreamNarration));
	this.AddComponent(new DreamRecallComp(this, this.c.dreamRecall));
	this.AddComponent(new DreamQuizComp(this, this.c.dreamQuiz));
	this.AddComponent(new ConceptLinkComp(this, this.c.conceptLink));
	this.AddComponent(new RealityCheckComp(this, this.c.realityCheck));
	this.AddComponent(new SignalsComp(this, this.c.signals));
	this.AddComponent(new StoryExploreComp(this, this.c.storyExplore));
	this.AddComponent(new VisualizationComp(this, this.c.visualization));
	this.AddComponent(new MediaComp(this, this.c.media));
	//this.AddComponent(new JourneyTrainingComp(this, this.c.journeyTraining)); // needs updating to work with entitySequence->shortText change
	this.AddComponent(new JourneyVisualizationComp(this, this.c.journeyVisualization));
	this.AddComponent(new JourneyGridComp(this, this.c.journeyGrid));
	//this.AddComponent(new JourneyEntryComp(this, this.c.journeyEntry)); // needs updating to work with entitySequence->shortText change

	// non-singleton comp-types at end (just for cleaner ordering atm)
	// ==========

	const AddComponentForAlarm = (sequence: AlarmSequence, alarm: EngineConfig_XAlarm)=>{
		if (alarm.type == AlarmType.Sound) {
			this.AddComponent(new SoundAlarmComp(this, sequence, alarm));
		} else if (alarm.type == AlarmType.Countdown) {
			this.AddComponent(new CountdownAlarmComp(this, sequence, alarm));
		} else if (alarm.type == AlarmType.Shake) {
			this.AddComponent(new ShakeAlarmComp(this, sequence, alarm));
		} else if (alarm.type == AlarmType.Light) {
			this.AddComponent(new LightAlarmComp(this, sequence, alarm));
		} else if (alarm.type == AlarmType.Script) {
			this.AddComponent(new ScriptAlarmComp(this, sequence, alarm));
		}
	};

	if (this.c.eeg.enabled) {
		// Why don't we check this.c.eeg.alarmSequence.enabled here? Because it's supposed to always be enabled. (ui doesn't support disabling, since no point)
		this.c.eeg.alarmSequence.alarms.forEach(alarm=>AddComponentForAlarm(this.c.eeg.alarmSequence, alarm));
	}
	if (this.c.alarms.enabled) {
		for (const sequence of this.c.alarms.phaseAlarm_sequences.filter(a=>a.enabled || SequenceIsSemiEnabled(a))) {
			for (const alarm of sequence.alarms.filter(a=>a.enabled)) {
				AddComponentForAlarm(sequence, alarm);
			}
		}
	}
}


export function GetEngineConfigPanelsToShow(journeyUI: boolean) {
	return [
		!journeyUI && EffectCountsPanel,
		Variants_ConfigUI,
		General_ConfigUI,
		ModeSwitcher_ConfigUI,
		!journeyUI && Background_ConfigUI,
		Alerts_ConfigUI,
		!journeyUI && CameraPanel,
		!journeyUI && Gyro_ConfigUI,
		!journeyUI && EEG_ConfigUI,
		Breath_ConfigUI,

		// alarms and solvers
		Phases_ConfigUI,
		Alarms_ConfigUI,
		MicroSnooze_ConfigUI,
		!journeyUI && Memory_ConfigUI,
		MemoryPalace_ConfigUI,
		VR_ConfigUI,
		DreamTranscribe_ConfigUI,

		!journeyUI && DreamNarration_ConfigUI,
		DreamRecall_ConfigUI,
		DreamQuiz_ConfigUI,
		ConceptLink_ConfigUI,
		RealityCheck_ConfigUI,
		Signals_ConfigUI,
		StoryExplore_ConfigUI,
		Visualization_ConfigUI,
		Media_ConfigUI,
		JourneyTraining_ConfigUI,
		JourneyVisualization_ConfigUI,
		JourneyGrid_ConfigUI,
		JourneyEntry_ConfigUI,
	].filter(a=>a) as Array<React.ComponentType>;
}